import styled from 'styled-components';

export const Textthrough = styled.span`
    text-decoration: line-through;
`